'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _LoginBtn = require('../cart-view/cart-left/LoginBtn');

var _LoginBtn2 = _interopRequireDefault(_LoginBtn);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemOptionModal = (0, _createReactClass2.default)({
    displayName: 'ItemOptionModal',
    componentDidMount: function componentDidMount() {
        var _this = this;

        $('#itemOptionModal').modal('show');
        $("#itemOptionModal").on('hidden.bs.modal', function () {
            _this.props.handleHideModal();
        });
    },
    render: function render() {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'modal fade fade-' + (this.props.showModal ? "in" : "out"), id: 'itemOptionModal', tabIndex: '-1', role: 'dialog',
                    'aria-labelledby': 'exampleModalLongTitle', 'aria-hidden': 'true',
                    'data-keyboard': 'false', 'data-backdrop': 'static'
                },
                this.props.children
            )
        );
    }
});
exports.default = ItemOptionModal;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/ItemOptionModal.jsx
// module id = 500
// module chunks = 0